import React, { Component } from 'react';

// const TICK_RATE = 5000;

class Loading extends Component { // eslint-disable-line react/prefer-stateless-function
  // state = {
  //   dots: 0,
  // };

  // componentDidMount() {
  //   this.interval = setInterval(this.onTick, TICK_RATE);
  // }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // }

  // onTick = () => {
  //   this.setState(prevState => ({ dots: (prevState.dots + 1) % 4 }));
  // };

  render() {
  //   const { isCenter } = this.props;
  //   const { dots } = this.state;

    //   const classNames = ['Loading'];

    //   if (isCenter) {
    //     classNames.push('Loading_center');
    //   }

    return (
      <div>
        {/* <div className={classNames.join(' ')}> */}
        <small>
          {/* Loading {new Array(dots).fill(0).map(dot => '.')} */}
        </small>
      </div>
    );
  }
}

export default Loading;
